import React from 'react'
import styles from './styles.css'

import DashedLabel from 'App/components/DashedLabel'

export default function ReferralLabel({refId}) {
  return (
    <DashedLabel>
      <p>
        Estás usando el código de referidos: <span className={styles.refId}>{refId}</span>
      </p>
    </DashedLabel>
  )
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/ReferralLabel.js